import { MainLayout } from '@/components/layout/MainLayout';
import { BCCodeViewer } from '@/components/reference/BCCodeViewer';

export const BCCodePage = () => (
  <MainLayout>
    <div className="flex flex-col gap-4 h-full">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">BC Building Code</h1>
        <p className="text-sm text-gray-500 mt-0.5">Quick reference, bookmarks, and the full code text.</p>
      </div>
      <div className="flex-1 min-h-0">
        <BCCodeViewer canUpload />
      </div>
    </div>
  </MainLayout>
);
